export default "__VITE_ASSET__CV_TcUr4__"